'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageView = pageView;
exports.projectAddEvent = projectAddEvent;

/* injects from baggage-loader */

var ga = require('react-ga');

var GA_TRACKING_ID = 'UA-2325415-14';
var gaOptions = { debug: process.env.NODE_ENV === 'development' };

ga.initialize(GA_TRACKING_ID, gaOptions);

function pageView(path) {
  ga.pageview(path);
}

function projectAddEvent(userId) {
  ga.event({ category: 'User',
    action: 'Created a Project',
    userId: userId
  });
}


//////////////////
// WEBPACK FOOTER
// ./app/store/ga.js
// module id = 231
// module chunks = 1